function replaceUlWithText(ulElement) {
  if (!ulElement || ulElement.tagName !== 'UL') {
      console.error('Provided element is not a UL element.');
      return;
  }
  let listItems = ulElement.querySelectorAll('li');
  let texts = Array.from(listItems).map(li => li.textContent.trim());
  let combinedText = texts.join(', ');
  ulElement.outerHTML = combinedText + '<br />';
}

if ( typeof NutritionalInfo !== 'function' ) {

  class NutritionalInfo extends HTMLElement {
    constructor() {
      super();
      let contentDOM = ``;
      const listitems = this.querySelector('.metafield-single_line_text_field-array')
      listitems && replaceUlWithText(listitems)
      let content = `<p>${this.innerHTML.replace(/<p>|<div>/g, '').replace(/<\/p>|<\/div>/g, '')}</p>`;
      let titleFlag = false;
      content = content.replace(/<\/p>|<\/div>/g, '');
      // Add BREAK; to theme settings to break line
      content = content.replace('BREAK;', ' <br>');
      content = content.split('<p>');
      for ( let i = 1; i < content.length; i++ ) {
        let contentArray = content[i].split(/<br>|<br\/>|\n/g);

        contentDOM += `<div class="table">`

        if ( this.dataset.titleLabelLeft != '' || this.dataset.titleLabelRight != '' ) {
          if ( !titleFlag ) {
            titleFlag = true;
            contentDOM += `<span class="table-line table-line--heading">`;
            if ( this.dataset.titleLabelLeft != '' ) {
              contentDOM += `<span>${this.dataset.titleLabelLeft}</span>`;
            }
            if ( this.dataset.titleLabelRight != '' ) {
              contentDOM += `<span>${this.dataset.titleLabelRight}</span>`;
            }
            contentDOM += `</span>`;
          }
        }

        for ( let j = 0; j < contentArray.length; j++ ) {
          if (contentArray[j].length > 0 && contentArray[j].replace(/\s/g, '').length != 0 ) {
            let contentBlockArrayPrepare = contentArray[j].replace(',', '#SD*@N!SA')
            let contentBlockArray = contentBlockArrayPrepare.split('#SD*@N!SA');
            console.log(123, contentBlockArray)
            if (contentBlockArray[1] != ' ') {
              contentDOM += `<span class="table-line ${(contentArray[j].includes('-') ? 'table-line--indent1' : '')}">`;
              for ( let k = 0; k < contentBlockArray.length; k++ ) {
                if ( contentBlockArray[k].length > 0 && contentBlockArray[k].replace(/\s/g, '').length != 0 ) {
                  contentDOM += `<span>${contentBlockArray[k].replace('-', '')}</span>`
                }
              }
            }
            contentDOM += `</span>`;
          }
        }

        contentDOM += `</div>`;

      }
      
      this.innerHTML = contentDOM;

    }
  }

  if ( typeof customElements.get('nutritional-info') == 'undefined' ) {
    customElements.define('nutritional-info', NutritionalInfo);
	}

}

